import './CreateDialog.scss';

import { useTranslation } from 'react-i18next';
import { MapContainer, Polyline, TileLayer } from 'react-leaflet';

import { defaultTileLayerProvider } from '../../../../../utils/constants/map';

function GeoLocation({ data }) {
  const { t } = useTranslation();

  return (
    <>
      {data?.length ? (
        <MapContainer
          center={[41.6086, 21.7453]} // mk coordinates
          maxBounds={[
            [42.416318, 19.839309],
            [40.553642, 23.706547],
          ]}
          zoom={7}
          minZoom={6}
          maxZoom={19}
          scrollWheelZoom={false}
          className="map"
        >
          <TileLayer url={defaultTileLayerProvider} />
          <Polyline positions={data} color="blue" />
        </MapContainer>
      ) : (
        <div className="no-location-available">
          <i>{t('This route has no location defined')}</i>
        </div>
      )}
    </>
  );
}

export default GeoLocation;
